import { Component } from 'react';
import ContentRoutes from 'ContentUtils/Routes';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Redu... Remove this comment to see the full error message
import NotificationList from 'ReduxMessenger/components/NotificationList';
import FloatingEditor from '../compose/components/FloatingEditor';
import RequireElevatedJitaPrompt from 'svh-workspace-ui-lib/elevated-jita/RequireElevatedJitaPrompt';
import { NotificationPreemptor } from 'svh-workspace-ui-lib/notifications/public/components';
import DebugOverlay from 'conversations-error-reporting/debug-overlay/DebugOverlay';
import PubSubHealthCheck from '../pubsub/components/PubSubHealthCheck';
import NetworkStatistics from '../performance-reporting/components/NetworkStatistics';
import TopLevelErrorBoundary from '../error-messages/components/TopLevelErrorBoundary';
import { InboxFeedbackLoader } from './InboxFeedbackLoader';
import styled from 'foundations-theming/utils';
import { View } from 'foundations-components/components/View';
// Uncomment and invoke below to update the skeleton state
// import { generateSkeletonState } from '../skeleton-state/generateSkeletonState';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledNotificationList = styled(NotificationList).withConfig({
  displayName: "Application__StyledNotificationList",
  componentId: "e5jt43-0"
})([".alert{max-inline-size:700px;}"]);
class Application extends Component {
  constructor(...args) {
    super(...args);
    this.removeSkeletonPreloader = () => {
      // Uncomment this line and the corresponding import to update the skeleton state
      // generateSkeletonState();
      const element = document.getElementById('inbox-skeleton-state-preloader');
      if (element && element.parentNode) {
        element.parentNode.removeChild(element);
      }
    };
  }
  componentDidMount() {
    const {
      gates
    } = this.props;
    const nav = document.getElementById('hs-nav-v3');
    if (nav) {
      nav.classList.add('no-bottom-margin');
    }
    ContentRoutes.init(gates);
    this.removeSkeletonPreloader();
  }
  render() {
    if (!this.props.hasConnectedEmailDataAccess) {
      return /*#__PURE__*/_jsx(RequireElevatedJitaPrompt, {
        currentUserEmail: this.props.currentUserEmail,
        portalDomain: this.props.portalDomain
      });
    }
    return /*#__PURE__*/_jsx(View, {
      "data-test-id": "inbox-container",
      inset: "0",
      position: "absolute",
      overflowX: "auto",
      overflowY: "hidden",
      children: /*#__PURE__*/_jsxs(TopLevelErrorBoundary, {
        children: [/*#__PURE__*/_jsx(StyledNotificationList, {}), /*#__PURE__*/_jsx(InboxFeedbackLoader, {}), this.props.children, /*#__PURE__*/_jsx(FloatingEditor, {}), /*#__PURE__*/_jsx(DebugOverlay, {
          renderNetworkStatistics: () => {
            return /*#__PURE__*/_jsx(NetworkStatistics, {});
          }
        }), /*#__PURE__*/_jsx(PubSubHealthCheck, {}), /*#__PURE__*/_jsx(NotificationPreemptor, {
          focusedViewMemberThreadId: this.props.focusedViewMemberThreadId
        })]
      })
    });
  }
}
Application.displayName = 'Application';
export default Application;